import { useRef } from "react";
import { useCsvContext } from "../context/CsvContext";

export const useCsvHandler = () => {
  const { readCSV, reset } = useCsvContext();
  const resetRef = useRef<() => void>(null);

  const handleFieldChange = (file: File | null) => {
    if (file) {
      readCSV(file);
    }
  };

  const handleReset = () => {
    reset();
    if (resetRef.current) {
      resetRef.current();
    }
  };

  return {
    handleFieldChange,
    handleReset,
    resetRef,
  };
};
